(() => {
  "use strict";

  const ROOT_ID = "ModTimeReveal";
  const DISMISS_KEY = "modtime_reveal_dismissed_at_v1";
  const COMPLETE_KEY = "modtime_reveal_completed_at_v1";
  const PENDING_KEY = "modtime_reveal_requested_at_v2"; // Accepted request only, not confirmed consent.
  const DAY = 86400000;
  const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const EXCLUDED_PATHS = ["/checkout", "/checkouts"];
  const SEEN_KEY = "modtime_reveal_seen_v3";
  const SUBMITTED_KEY = "modtime_reveal_submitted_v3";
  const TEASER_DELAY_MS = 2000;
  const AUTO_DELAY_MS = 10000;
  const VISIT_TIME_KEY = "modtime_reveal_active_ms_v1";
  const REEL_TIMING = Object.freeze({
    tickMs: 215,
    stopMs: Object.freeze([4300, 5000, 5700]),
    settleMs: 160,
    tailCells: Object.freeze([0, 3, 6])
  });

  const root = document.getElementById(ROOT_ID);
  if (!root) return;

  const preview = root.dataset.preview === "true";
  const pagePath = location.pathname.replace(/^\/[a-z]{2}(?:-[a-z]{2})?(?=\/|$)/i, "") || "/";
  if (EXCLUDED_PATHS.some(path => pagePath === path || pagePath.startsWith(path + "/"))) return;
  const country = root.dataset.country || "";
  const currency = root.dataset.currency || "EUR";
  const isUS = country === "US" && currency === "USD";
  const language = (root.dataset.language || document.documentElement.lang || "en").split("-")[0];
  const locale = ["en", "fr", "de"].includes(language) ? language : "en";
  const COPY = {
    en: { teaser: "TRY YOUR LUCK", close: "Close welcome offer", eyebrow: "A WIN IS GUARANTEED", invite: "Try your luck!", inviteLead: "Try your ", inviteAccent: "luck!", jackpot: "Jackpot.", wonLead: "You won", wonAccent: "{reward} off.", spinning: "Revealing your offer…", won: "Your offer: {reward} off.", support: "Spin the machine and claim your prize.", ready: "Your offer is ready. Join the newsletter to receive your code by email.", spin: "SPIN THE MACHINE", claim: "CLAIM {reward}", no: "No, thanks", unlocked: "{reward} UNLOCKED", title: "Get my code.", formSupport: "Join the ModTime Newsletter. We’ll email you the code for the reward you unlocked.", email: "Email address", consent: "I agree to receive marketing emails from ModTime. I can unsubscribe at any time. ", privacy: "Privacy Policy", error: "Please enter a valid email address.", consentError: "Please confirm your email marketing consent.", submit: "GET MY CODE", loading: "PREPARING WATCHES…", sending: "SENDING…", successTitle: "Check your inbox.", success: "Look for your ModTime welcome email — your reward code will be inside. Check your spam folder too.", finish: "BACK TO THE STORE", terms: "Selected watches only. Minimum €200 before the discount. One use per code per customer. Cannot be combined with other discounts.", pending: "Your request was received. Check your inbox for your ModTime welcome email and reward code." },
    fr: { teaser: "TENTEZ VOTRE CHANCE", close: "Fermer l’offre de bienvenue", eyebrow: "UN GAIN GARANTI", invite: "Tentez votre chance !", inviteLead: "Tentez votre ", inviteAccent: "chance !", jackpot: "Jackpot.", wonLead: "Vous avez gagné", wonAccent: "{reward} de réduction.", spinning: "Votre offre arrive…", won: "Votre offre : {reward}.", support: "Faites tourner la machine et récupérez votre récompense.", ready: "Votre offre est prête. Inscrivez-vous à la newsletter pour recevoir votre code par e-mail.", spin: "FAIRE TOURNER LA MACHINE", claim: "OBTENIR {reward}", no: "Non, merci", unlocked: "{reward} DÉBLOQUÉS", title: "Obtenir mon code.", formSupport: "Rejoignez la newsletter ModTime. Nous vous enverrons le code de votre récompense par e-mail.", email: "Adresse e-mail", consent: "J’accepte de recevoir les e-mails marketing de ModTime. Je peux me désinscrire à tout moment. ", privacy: "Politique de confidentialité", error: "Veuillez saisir une adresse e-mail valide.", consentError: "Veuillez confirmer votre accord pour recevoir nos e-mails.", submit: "OBTENIR MON CODE", loading: "PRÉPARATION…", sending: "ENVOI…", successTitle: "Consultez vos e-mails.", success: "Votre code vous attendra dans l’e-mail de bienvenue ModTime. Pensez aussi à vérifier les spams.", finish: "RETOUR À LA BOUTIQUE", terms: "Montres sélectionnées. Minimum 200 € avant réduction. Une utilisation de chaque code par client. Non cumulable.", pending: "Demande reçue. Consultez votre boîte mail pour retrouver votre e-mail de bienvenue ModTime et votre code." },
    de: { teaser: "VERSUCH DEIN GLÜCK", close: "Willkommensangebot schließen", eyebrow: "EIN GEWINN IST GARANTIERT", invite: "Versuch dein Glück!", inviteLead: "Versuch dein ", inviteAccent: "Glück!", jackpot: "Jackpot.", wonLead: "Du hast gewonnen", wonAccent: "{reward} Rabatt.", spinning: "Dein Angebot wird aufgedeckt…", won: "Dein Angebot: {reward} Rabatt.", support: "Dreh die Walzen und sichere dir deinen Gewinn.", ready: "Dein Angebot ist bereit. Abonniere den Newsletter und erhalte deinen Code per E-Mail.", spin: "WALZEN DREHEN", claim: "{reward} SICHERN", no: "Nein, danke", unlocked: "{reward} FREIGESCHALTET", title: "Meinen Code erhalten.", formSupport: "Abonniere den ModTime Newsletter. Wir senden dir den Code für deinen Gewinn per E-Mail.", email: "E-Mail-Adresse", consent: "Ich möchte Marketing-E-Mails von ModTime erhalten. Ich kann mich jederzeit abmelden. ", privacy: "Datenschutzerklärung", error: "Bitte gib eine gültige E-Mail-Adresse ein.", consentError: "Bitte bestätige deine Einwilligung zum E-Mail-Marketing.", submit: "MEINEN CODE ERHALTEN", loading: "WIRD VORBEREITET…", sending: "WIRD GESENDET…", successTitle: "Prüfe dein Postfach.", success: "Deinen Rabattcode findest du in deiner ModTime-Willkommensmail. Prüfe auch den Spam-Ordner.", finish: "ZURÜCK ZUM SHOP", terms: "Ausgewählte Uhren. Mindestens 200 € vor Rabatt. Jeder Code einmal pro Kunde. Nicht kombinierbar.", pending: "Anfrage erhalten. Prüfe dein Postfach auf deine ModTime-Willkommensmail mit deinem Rabattcode." }
  };
  const copy = {...COPY[locale]};
  if (isUS) copy.terms = ({en:"Selected watches only. Minimum €200 before the discount (or the equivalent in your checkout currency). One use per code per customer. Cannot be combined with other discounts.",fr:"Montres sélectionnées. Minimum 200 € avant réduction (ou l’équivalent dans la devise du paiement). Une utilisation de chaque code par client. Non cumulable.",de:"Ausgewählte Uhren. Mindestens 200 € vor Rabatt (oder der entsprechende Betrag in deiner Zahlungswährung). Jeder Code einmal pro Kunde. Nicht kombinierbar."})[locale];
  const text = (selector, value) => root.querySelectorAll(selector).forEach(node => { node.textContent = value; });
  const rewards = [{id:"pct5", value:"5", unit:"%"},{id:"pct10", value:"10", unit:"%"},(isUS ? {id:"usd25", value:"25", unit:"$"} : {id:"eur20", value:"20", unit:"€"})];
  const REWARD_KEY = "modtime_reveal_reward_v2";
  let reward;
  try {
    const saved = JSON.parse(localStorage.getItem(REWARD_KEY) || "null");
    if (saved && Date.now() - saved.at < 365 * DAY) reward = rewards.find(item => item.id === (isUS && saved.id === "eur20" ? "usd25" : !isUS && saved.id === "usd25" ? "eur20" : saved.id));
  } catch (_) { /* private browsing or invalid storage */ }
  if (preview) reward = rewards.find(item => item.id === new URLSearchParams(location.search).get("reward")) || reward;
  if (!reward) {
    const random = new Uint32Array(1);
    do { crypto.getRandomValues(random); } while (random[0] === 4294967295);
    reward = rewards[random[0] % 3];
    try { localStorage.setItem(REWARD_KEY, JSON.stringify({id:reward.id,at:Date.now()})); } catch (_) { /* no durable reroll protection */ }
  }
  const rewardLabel = reward.unit === "$" ? "$25" : reward.unit === "€" ? (locale === "en" ? "€20" : "20\u00a0€") : reward.value + (locale === "en" ? "%" : "\u00a0%");
  const interpolate = value => value.replace("{reward}", rewardLabel);
  root.dataset.reward = reward.id;
  root.lang = locale;
  // Preserve the original teaser dot and heading emphasis from the approved markup.
  const teaserLabel = root.querySelector(".mtr-teaser");
  if (teaserLabel) {
    const dot = teaserLabel.querySelector(".mtr-teaser-dot");
    teaserLabel.replaceChildren(...(dot ? [dot] : []), document.createTextNode(copy.teaser));
  }
  const accentedHeading = (selector, lead, accent, lineBreak = false) => {
    const node = root.querySelector(selector);
    if (!node) return;
    const emphasis = document.createElement("em");
    emphasis.className = "mtr-title-accent";
    emphasis.textContent = accent;
    node.replaceChildren(document.createTextNode(lead), ...(lineBreak ? [document.createElement("br")] : []), emphasis);
  };
  root.querySelector(".mtr-close")?.setAttribute("aria-label", copy.close);
  text(".mtr-stage--reveal > .mtr-eyebrow", copy.eyebrow);
  accentedHeading(".mtr-title [data-copy=invite]", copy.inviteLead, copy.inviteAccent);
  accentedHeading(".mtr-title [data-copy=loading]", "", copy.jackpot);
  accentedHeading(".mtr-title [data-copy=unlocked]", copy.wonLead, interpolate(copy.wonAccent), true);
  text(".mtr-support [data-copy=invite]", copy.support);
  text(".mtr-support [data-copy=loading]", copy.spinning);
  text(".mtr-support [data-copy=unlocked]", copy.ready);
  text(".mtr-reveal-button [data-copy=invite]", copy.spin);
  text(".mtr-reveal-button [data-copy=loading]", copy.spinning);
  text(".mtr-reveal-button [data-copy=unlocked]", interpolate(copy.claim));
  text("[data-asset-loading]", copy.loading);
  text(".mtr-decline", copy.no);
  text(".mtr-stage--form > .mtr-eyebrow", interpolate(copy.unlocked));
  text("#mtr-title-form", copy.title);
  text(".mtr-stage--form > .mtr-support", copy.formSupport);
  text("label[for=mtr-email]", copy.email);
  const consentText = root.querySelector(".mtr-consent > span");
  if (consentText) {
    const link = consentText.querySelector("a");
    if (link) { link.textContent = copy.privacy; consentText.replaceChildren(document.createTextNode(copy.consent), link); }
  }
  text('[data-error="email"]', copy.error);
  text('[data-error="consent"]', copy.consentError);
  text('[data-submit="idle"]', copy.submit);
  text('[data-submit="loading"]', copy.sending);
  text(".mtr-microcopy", copy.terms);
  text(".mtr-stage--success > .mtr-eyebrow", copy.eyebrow);
  text(".mtr-stage--success .mtr-title", copy.successTitle);
  text(".mtr-stage--success > .mtr-support", copy.success);
  text(".mtr-finish", copy.finish);
  root.querySelector(".mtr-reels")?.setAttribute("aria-label", copy.spinning);
  const tagInput = root.querySelector('input[name="contact[tags]"]');
  if (tagInput) tagInput.value = `newsletter,modtime-reveal-v2,modtime-reward-${reward.id},modtime-lang-${locale}`;
  root.querySelectorAll(".mtr-track").forEach((track, index) => {
    track.dataset.result = [...reward.value.padStart(2, "0"), reward.unit][index];
    track.dataset.transientResults = index === 0 ? "0|1|2" : index === 1 ? (isUS ? "5|0|5" : "5|0|0") : (isUS ? "%|%|$" : "%|%|€");
  });
  const backdrop = root.querySelector(".mtr-backdrop");
  const dialog = root.querySelector(".mtr-dialog");
  const teaser = root.querySelector(".mtr-teaser");
  const closeButton = root.querySelector(".mtr-close");
  const declineButton = root.querySelector(".mtr-decline");
  const revealButton = root.querySelector(".mtr-reveal-button");
  const form = root.querySelector("form");
  const finishButton = root.querySelector(".mtr-finish");
  const resetButton = root.querySelector(".mtr-preview-reset");
  const status = root.querySelector(".mtr-status");
  const tracks = [...root.querySelectorAll(".mtr-track")];
  const assetNodes = [...root.querySelectorAll("[data-mtr-asset]")];
  const assets = assetNodes
    .map((node) => ({
      src: node.dataset.src,
      srcset: node.dataset.srcset || "",
      sizes: node.dataset.sizes || "480px",
      alt: node.dataset.alt || "ModTime custom watch"
    }))
    .filter((asset) => asset.src);
  const stages = [...root.querySelectorAll(".mtr-stage")];
  const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
  const assetLoadingCopy = revealButton?.querySelector("[data-asset-loading]");
  const inviteButtonCopy = revealButton?.querySelector('[data-copy="invite"]');
  let lastFocused = null;
  let isOpen = false;
  let revealing = false;
  let landed = false;
  let assetsReady = assets.length === 0;
  let assetLoadPromise = null;
  let exitReady = false;
  let inertedBranches = [];
  let pendingOpenSource = null;
  let reelAnimations = [];
  let spinStartedAt = null;
  let tracksBuilt = false;

  const getNumber = (key, fallback) => {
    const value = Number(root.dataset[key]);
    return Number.isFinite(value) ? value : fallback;
  };

  // Same-origin persistence; no email or fingerprint is stored. Session fallback
  // preserves navigation when durable browser storage is unavailable.
  const memoryStorage = new Map();
  const storageGet = (key) => {
    try { const value = Number(localStorage.getItem(key)); if (value > 0) return value; } catch (_) {}
    try { const value = Number(sessionStorage.getItem(key)); if (value > 0) return value; } catch (_) {}
    return memoryStorage.get(key) || 0;
  };
  const storageSet = (key, value) => {
    memoryStorage.set(key, Number(value));
    try { localStorage.setItem(key, String(value)); } catch (_) {}
    try { sessionStorage.setItem(key, String(value)); } catch (_) {}
  };
  const storageRemove = (key) => {
    memoryStorage.delete(key);
    try { localStorage.removeItem(key); } catch (_) {}
    try { sessionStorage.removeItem(key); } catch (_) {}
  };
  const hasSubmitted = () => [SUBMITTED_KEY, PENDING_KEY, COMPLETE_KEY].some(key => storageGet(key) > 0);
  const hasSeen = () => storageGet(SEEN_KEY) > 0 || storageGet(DISMISS_KEY) > 0;

  const isFresh = (key, days) => {
    const value = storageGet(key);
    return value > 0 && Date.now() - value < days * DAY;
  };

  const setStatus = (message) => { if (status) status.textContent = message; };

  const setPageInert = (enabled) => {
    if (!enabled) {
      inertedBranches.forEach(({ node, inert, ariaHidden }) => {
        node.inert = inert;
        if (ariaHidden === null) node.removeAttribute("aria-hidden");
        else node.setAttribute("aria-hidden", ariaHidden);
      });
      inertedBranches = [];
      return;
    }

    let branch = root;
    while (branch?.parentElement) {
      const parent = branch.parentElement;
      [...parent.children].forEach((node) => {
        if (node === branch || !(node instanceof HTMLElement) || ["SCRIPT", "STYLE", "LINK"].includes(node.tagName)) return;
        inertedBranches.push({ node, inert: node.inert, ariaHidden: node.getAttribute("aria-hidden") });
        node.inert = true;
        node.setAttribute("aria-hidden", "true");
      });
      if (parent === document.body) break;
      branch = parent;
    }
  };

  const getFocusable = () => [...dialog.querySelectorAll(
    'button:not([disabled]), a[href], input:not([disabled]), [tabindex]:not([tabindex="-1"])'
  )].filter((node) => !node.hidden && node.offsetParent !== null);

  const showStage = (name) => {
    root.dataset.stage = name;
    stages.forEach((stage) => {
      const active = stage.dataset.stage === name;
      stage.hidden = !active;
      stage.classList.toggle("is-entering", active);
      if (active) {
        const heading = stage.querySelector(".mtr-title[id]");
        if (heading) dialog.setAttribute("aria-labelledby", heading.id);
      }
    });
  };

  const setCopy = (state) => {
    root.querySelectorAll("[data-copy]").forEach((node) => {
      node.hidden = node.dataset.copy !== state;
    });
  };

  const visualRandomInt = (max) => {
    const values = new Uint32Array(1);
    const limit = Math.floor(4294967296 / max) * max;
    do { crypto.getRandomValues(values); } while (values[0] >= limit);
    return values[0] % max;
  };
  const shuffleVisuals = (items) => {
    for (let i = items.length - 1; i > 0; i--) {
      const j = visualRandomInt(i + 1);
      [items[i], items[j]] = [items[j], items[i]];
    }
    return items;
  };
  const buildTracks = () => {
    if (tracksBuilt || !tracks.length || !assets.length) return;
    tracks.forEach((track, reelIndex) => {
      const fragment = document.createDocumentFragment();
      const symbols = (track.dataset.transientResults || "").split("|").filter(Boolean);
      const pool = shuffleVisuals([
        ...Array.from({length: 14 + reelIndex * 2}, () => ({asset: visualRandomInt(assets.length)})),
        ...Array.from({length: 7 + reelIndex}, () => ({symbol: symbols[visualRandomInt(symbols.length)]}))
      ]);
      const sequence = [{asset: reelIndex % assets.length}, ...pool,
        {symbol: symbols[visualRandomInt(symbols.length)]},
        {symbol: track.dataset.result, final: true}];
      sequence.forEach((item, index) => {
        const cell = document.createElement("div");
        cell.className = "mtr-cell";
        if (item.asset !== undefined) {
          const asset = assets[item.asset];
          const image = document.createElement("img");
          image.alt = ""; image.width = 960; image.height = 960;
          image.loading = index === 0 ? "eager" : "lazy";
          image.fetchPriority = index === 0 ? "high" : "low";
          image.decoding = "async"; image.dataset.assetIndex = String(item.asset);
          image.sizes = asset.sizes; if (asset.srcset) image.srcset = asset.srcset;
          image.src = asset.src; cell.appendChild(image);
          cell.dataset.visualType = "watch";
        } else {
          cell.className += " mtr-cell--result " + (item.final ? "mtr-cell--final" : "mtr-cell--transient");
          cell.setAttribute("aria-hidden", "true");
          const label = document.createElement("span"); label.textContent = item.symbol;
          cell.appendChild(label); cell.dataset.visualType = "reward-symbol";
        }
        fragment.appendChild(cell);
      });
      track.replaceChildren(fragment);
      track.dataset.transientIndices = "";
    });
    tracksBuilt = true;
  };

  const preloadAssets = () => Promise.all(assets.map((asset) => new Promise((resolve) => {
    const image = new Image();
    image.onload = () => resolve({ src: asset.src, ok: true });
    image.onerror = () => resolve({ src: asset.src, ok: false });
    if (asset.srcset) image.srcset = asset.srcset;
    image.sizes = asset.sizes;
    image.src = asset.src;
  })));

  const hydrateTrackImages = () => Promise.all([...root.querySelectorAll(".mtr-track img")].map((image) => {
    image.loading = "eager";
    if (image.complete && image.naturalWidth > 0) return Promise.resolve(true);
    return image.decode().then(() => true).catch(() => false);
  }));

  const ensureAssets = () => {
    if (!tracksBuilt) {
      buildTracks();
      resetReels();
    }
    if (assetsReady) return Promise.resolve([]);
    if (assetLoadPromise) return assetLoadPromise;
    if (revealButton) revealButton.disabled = true;
    if (assetLoadingCopy) assetLoadingCopy.hidden = false;
    if (inviteButtonCopy) inviteButtonCopy.hidden = true;
    setStatus(copy.loading);
    assetLoadPromise = Promise.race([preloadAssets(), new Promise(resolve => window.setTimeout(() => resolve(assets.map(asset => ({src:asset.src,ok:false}))), 6000))]).then(async (results) => {
      await Promise.race([hydrateTrackImages(), new Promise(resolve => window.setTimeout(resolve, 1500))]);
      assetsReady = true;
      const failed = results.filter((result) => !result.ok);
      root.classList.toggle("has-asset-error", failed.length > 0);
      if (revealButton) revealButton.disabled = false;
      if (assetLoadingCopy) assetLoadingCopy.hidden = true;
      if (inviteButtonCopy && !revealing && !landed) inviteButtonCopy.hidden = false;
      setStatus(copy.support);
      return results;
    });
    return assetLoadPromise;
  };

  const resetReels = () => {
    if (!revealButton) return;
    reelAnimations.forEach((animation) => animation.cancel());
    reelAnimations = [];
    tracks.forEach((track) => {
      track.style.transition = "none";
      track.style.transform = "translate3d(0, 0, 0)";
      delete track.dataset.stopDurationMs;
      delete track.dataset.stopElapsedMs;
    });
    root.classList.remove("is-landed");
    delete root.dataset.spinPhase;
    delete root.dataset.spinStopPlan;
    spinStartedAt = null;
    revealing = false;
    landed = false;
    setCopy("invite");
    revealButton.disabled = !assetsReady;
    showStage("reveal");
  };

  const positionReels = () => {
    tracks.forEach((track) => {
      const cell = track.querySelector(".mtr-cell");
      const count = track.children.length;
      const targetIndex = count - 1;
      const distance = cell.getBoundingClientRect().height * targetIndex;
      track.style.transition = "none";
      track.style.transform = `translate3d(0, -${distance}px, 0)`;
    });
  };

  const animateReelsContinuously = () => {
    reelAnimations.forEach(animation => animation.cancel());
    reelAnimations = [];
    const startedAt = performance.now();
    spinStartedAt = startedAt;
    reelAnimations = tracks.map((track, reelIndex) => {
      const cellHeight = track.querySelector(".mtr-cell").getBoundingClientRect().height;
      const distance = cellHeight * (track.children.length - 1);
      const duration = REEL_TIMING.stopMs[reelIndex];
      const acceleration = 280;
      const brakeStart = duration * 0.44;
      const braking = duration - brakeStart;
      const totalArea = acceleration / 2 + (brakeStart - acceleration) + braking / 3;
      const positionAt = time => {
        if (time <= acceleration) return (time * time / (2 * acceleration)) / totalArea;
        if (time <= brakeStart) return (acceleration / 2 + time - acceleration) / totalArea;
        const u = (time - brakeStart) / braking;
        return (acceleration / 2 + brakeStart - acceleration + braking * (u - u * u + u * u * u / 3)) / totalArea;
      };
      const keyframes = Array.from({length:61}, (_, i) => ({
        transform: `translate3d(0, -${distance * positionAt(duration * i / 60)}px, 0)`,
        offset: i / 60
      }));
      track.dataset.stopDurationMs = String(duration);
      track.style.transition = "none";
      const animation = track.animate(keyframes, {duration,fill:"forwards",easing:"linear"});
      animation.finished.then(() => {
        const elapsedMs = Math.round(performance.now() - startedAt);
        track.dataset.stopElapsedMs = String(elapsedMs);
        track.style.transform = `translate3d(0, -${distance}px, 0)`;
        root.dispatchEvent(new CustomEvent("mtr:reel-stop", {detail:{reelIndex,value:track.dataset.result,plannedMs:duration,elapsedMs}}));
        animation.cancel();
      }).catch(() => {});
      return animation;
    });
    root.dataset.spinStopPlan = REEL_TIMING.stopMs.join(",");
    return {maxDuration: Math.max(...REEL_TIMING.stopMs)};
  };

  const reveal = () => {
    if (!revealButton) return;
    if (!assetsReady) {
      setStatus(copy.loading);
      return;
    }
    if (revealing) return;
    if (landed) {
      showStage("form");
      window.setTimeout(() => root.querySelector("#mtr-email")?.focus(), 50);
      setStatus(interpolate(copy.won) + " " + copy.ready);
      return;
    }

    revealing = true;
    revealButton.disabled = true;
    setCopy("loading");
    setStatus(copy.spinning);

    const animate = !reducedMotion.matches;
    const completeReveal = () => {
      revealing = false;
      landed = true;
      root.classList.add("is-landed");
      root.dataset.spinPhase = "landed";
      revealButton.disabled = false;
      setCopy("unlocked");
      positionReels();
      root.querySelector(".mtr-reels")?.setAttribute("aria-label", interpolate(copy.won));
      setStatus(interpolate(copy.won));
      root.dispatchEvent(new CustomEvent("mtr:reveal-complete", {
        detail: {
          stopPlanMs: REEL_TIMING.stopMs,
          settleMs: REEL_TIMING.settleMs,
          elapsedMs: spinStartedAt === null ? 0 : Math.round(performance.now() - spinStartedAt)
        }
      }));
    };

    if (animate) {
      root.dataset.spinPhase = "spinning";
      animateReelsContinuously();
      Promise.all(reelAnimations.map((animation) => animation.finished.catch(() => null)))
        .then(() => window.setTimeout(completeReveal, REEL_TIMING.settleMs));
    } else {
      root.dataset.spinPhase = "finalizing";
      spinStartedAt = performance.now();
      window.requestAnimationFrame(() => positionReels());
      window.setTimeout(completeReveal, 180);
    }
  };

  const open = (source = "automatic") => {
    if (isOpen) return;
    if (!preview && (hasSubmitted() || (source !== "teaser" && hasSeen()))) return;
    if (document.visibilityState === "hidden" && source !== "teaser") { pendingOpenSource = source; return; }
    if (!preview) storageSet(SEEN_KEY, Date.now());
    lastFocused = document.activeElement;
    isOpen = true;
    teaser.hidden = true;
    backdrop.hidden = false;
    document.body.classList.add("mtr-scroll-locked");
    setPageInert(true);
    window.requestAnimationFrame(() => backdrop.classList.add("is-open"));
    window.setTimeout(() => {
      dialog.scrollTop = 0;
      dialog.focus({ preventScroll: true });
    }, 80);
    setStatus(`Welcome offer opened from ${source}.`);
    ensureAssets();
  };

  const close = (reason = "dismissed") => {
    if (!isOpen) return;
    isOpen = false;
    backdrop.classList.remove("is-open");
    document.body.classList.remove("mtr-scroll-locked");
    setPageInert(false);
    if (!preview && reason !== "completed") storageSet(DISMISS_KEY, Date.now());
    window.setTimeout(() => { backdrop.hidden = true; }, 240);
    teaser.hidden = !preview && hasSubmitted();
    const meaningfulOrigin = lastFocused
      && lastFocused !== document.body
      && lastFocused !== document.documentElement
      && typeof lastFocused.focus === "function";
    if (meaningfulOrigin) lastFocused.focus();
    else if (!teaser.hidden) teaser.focus();
  };

  const validate = () => {
    if (!form) return false;
    const email = form.querySelector('input[type="email"]');
    const consent = form.querySelector('input[type="checkbox"]');
    const emailError = form.querySelector('[data-error="email"]');
    const consentError = form.querySelector('[data-error="consent"]');
    const validEmail = EMAIL_RE.test(email.value.trim());
    const validConsent = consent.checked;

    email.setAttribute("aria-invalid", String(!validEmail));
    emailError.hidden = validEmail;
    consentError.hidden = validConsent;
    if (!validEmail) email.focus();
    else if (!validConsent) consent.focus();
    return validEmail && validConsent;
  };

  const showSuccess = (recordRequest = true) => {
    showStage("success");
    if (!preview && recordRequest) {
      storageSet(PENDING_KEY, Date.now());
      storageSet(SUBMITTED_KEY, Date.now());
      storageRemove(DISMISS_KEY);
    }
    teaser.hidden = true;
    setStatus(copy.pending);
    window.setTimeout(() => finishButton.focus(), 60);
  };

  const submitPreview = (event) => {
    if (!preview || !form) return;
    event.preventDefault();
    if (!validate()) return;
    const submit = form.querySelector(".mtr-submit");
    submit.disabled = true;
    form.querySelector('[data-submit="idle"]').hidden = true;
    form.querySelector('[data-submit="loading"]').hidden = false;
    setStatus("Preparing the preview success state. No data is being sent.");
    window.setTimeout(() => {
      submit.disabled = false;
      form.querySelector('[data-submit="idle"]').hidden = false;
      form.querySelector('[data-submit="loading"]').hidden = true;
      showSuccess();
    }, 850);
  };

  // Klaviyo's public client subscription API uses the target list's configured opt-in process.
  // A 202 response is only an accepted request, never proof of confirmed consent.
  let submitting = false;
  const submitKlaviyo = async (event) => {
    if (preview || root.dataset.subscriptionProvider !== "klaviyo") return;
    event.preventDefault();
    if (submitting || hasSubmitted() || !validate() || !form.reportValidity()) return;
    submitting = true;
    const submit = form.querySelector('.mtr-submit');
    const idle = form.querySelector('[data-submit="idle"]');
    const loading = form.querySelector('[data-submit="loading"]');
    const error = form.querySelector('[data-error="network"]');
    if (error) error.hidden = true;
    submit.disabled = true;
    idle.hidden = true;
    loading.hidden = false;
    setStatus(copy.sending);
    const controller = new AbortController();
    const timeout = window.setTimeout(() => controller.abort(), 15000);
    try {
      const response = await fetch(`https://a.klaviyo.com/client/subscriptions/?company_id=${encodeURIComponent(root.dataset.klaviyoSiteId)}`, {
        method: "POST",
        headers: {"content-type":"application/vnd.api+json",accept:"application/vnd.api+json",revision:"2026-07-15"},
        signal: controller.signal,
        body: JSON.stringify({data:{type:"subscription",attributes:{custom_source:"ModTime welcome offer v2",profile:{data:{type:"profile",attributes:{email:form.querySelector('input[type="email"]').value.trim(),locale,properties:{mt_reward:reward.id,mt_popup_language:locale,mt_popup_country:country,mt_popup_currency:currency,mt_popup_version:"2026-10-15-v2"},subscriptions:{email:{marketing:{consent:"SUBSCRIBED"}}}}}}},relationships:{list:{data:{type:"list",id:root.dataset.klaviyoListId}}}}})
      });
      if (response.status !== 202) throw new Error(`HTTP ${response.status}`);
      showSuccess();
      form.querySelector('input[type="email"]').value = "";
    } catch (_) {
      const messages = {en:"We could not confirm your request. Check your inbox before trying again, or contact support@modtime.store.",fr:"Nous n’avons pas pu confirmer votre demande. Vérifiez vos e-mails avant de réessayer, ou contactez support@modtime.store.",de:"Wir konnten deine Anfrage nicht bestätigen. Prüfe dein Postfach, bevor du es erneut versuchst, oder kontaktiere support@modtime.store."};
      if (error) { error.textContent = messages[locale]; error.hidden = false; }
      setStatus(messages[locale]);
    } finally {
      window.clearTimeout(timeout);
      submitting = false;
      submit.disabled = false;
      idle.hidden = false;
      loading.hidden = true;
    }
  };

  const onKeydown = (event) => {
    if (!isOpen) return;
    if (event.key === "Escape") {
      event.preventDefault();
      close("escape");
      return;
    }
    if (event.key !== "Tab") return;
    const focusable = getFocusable();
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  };

  const onResize = () => {
    if (landed) positionReels("final");
  };

  const installProductionTriggers = () => {
    teaser.hidden = true;
    if (hasSubmitted()) return;
    window.setTimeout(() => { teaser.hidden = hasSubmitted() || isOpen; }, TEASER_DELAY_MS);
    if (hasSeen()) return;

    // Active time belongs to this visit, not to a page or language. No scroll gate.
    // Session storage survives navigation; blocked storage falls back to this page.
    let elapsed = 0;
    try {
      const saved = Number(sessionStorage.getItem(VISIT_TIME_KEY));
      if (Number.isFinite(saved) && saved > 0) elapsed = Math.min(saved, AUTO_DELAY_MS);
    } catch (_) {}
    let activeSince = document.visibilityState === "visible" ? performance.now() : null;
    let timer = null;
    let requested = false;
    const saveTime = () => {
      if (activeSince !== null) {
        const now = performance.now();
        elapsed = Math.min(AUTO_DELAY_MS, elapsed + Math.max(0, now - activeSince));
        activeSince = now;
      }
      try { sessionStorage.setItem(VISIT_TIME_KEY, String(elapsed)); } catch (_) {}
    };
    const requestOpen = () => {
      if (requested || hasSubmitted() || hasSeen() || isOpen) return;
      requested = true;
      const attempt = () => open("welcome delay");
      // Never leave opening stuck behind a queued/rejected Web Locks request.
      try {
        if (navigator.locks?.request) {
          Promise.resolve(navigator.locks.request("modtime-reveal-auto", { ifAvailable: true }, lock => {
            if (lock) attempt();
            else { requested = false; timer = window.setTimeout(tick, 250); }
          })).catch(attempt);
        } else attempt();
      } catch (_) { attempt(); }
    };
    const tick = () => {
      timer = null;
      saveTime();
      if (hasSubmitted() || hasSeen() || isOpen) return;
      if (document.visibilityState !== "visible") return;
      if (elapsed >= AUTO_DELAY_MS) requestOpen();
      else timer = window.setTimeout(tick, Math.min(1000, AUTO_DELAY_MS - elapsed));
    };
    const pause = () => {
      saveTime();
      activeSince = null;
      window.clearTimeout(timer);
      timer = null;
    };
    const resume = () => {
      if (document.visibilityState !== "visible") return;
      activeSince = performance.now();
      window.clearTimeout(timer);
      tick();
    };
    document.addEventListener("visibilitychange", () => {
      if (document.visibilityState === "hidden") pause();
      else resume();
    });
    window.addEventListener("pagehide", pause);
    window.addEventListener("pageshow", event => { if (event.persisted) resume(); });
    tick();
  };

  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "visible" && pendingOpenSource) {
      const source = pendingOpenSource; pendingOpenSource = null; open(source);
    }
  });
  window.addEventListener("storage", event => {
    if (![SUBMITTED_KEY, PENDING_KEY, COMPLETE_KEY].includes(event.key) || !hasSubmitted()) return;
    if (isOpen) close("completed");
    teaser.hidden = true;
  });
  teaser.addEventListener("click", () => open("teaser"));
  teaser.addEventListener("pointerenter", ensureAssets, { once: true });
  teaser.addEventListener("focus", ensureAssets, { once: true });
  closeButton.addEventListener("click", () => close("close button"));
  declineButton.addEventListener("click", () => close("decline"));
  if (revealButton) revealButton.addEventListener("click", reveal);
  if (finishButton) finishButton.addEventListener("click", () => close("completed"));
  backdrop.addEventListener("click", (event) => { if (event.target === backdrop) close("backdrop"); });
  if (form) {
    form.addEventListener("submit", submitPreview);
    form.addEventListener("submit", submitKlaviyo);
    const emailInput = form.querySelector('input[type="email"]');
    if (emailInput) {
      emailInput.addEventListener("blur", (event) => {
        if (!event.target.value) return;
        const valid = EMAIL_RE.test(event.target.value.trim());
        event.target.setAttribute("aria-invalid", String(!valid));
        const emailError = form.querySelector('[data-error="email"]');
        if (emailError) emailError.hidden = valid;
      });
    }
  }
  document.addEventListener("keydown", onKeydown);
  window.addEventListener("resize", onResize, { passive: true });

  if (resetButton) {
    resetButton.addEventListener("click", () => {
      form.reset();
      root.querySelectorAll(".mtr-error").forEach((node) => { node.hidden = true; });
      resetReels();
      teaser.hidden = false;
      if (!isOpen) open("preview reset");
      else dialog.focus();
    });
  }

  const serverSuccess = Boolean(root.querySelector('.mtr-stage--success')) && !revealButton;
  if (serverSuccess) {
    storageSet(COMPLETE_KEY, Date.now());
    storageRemove(DISMISS_KEY);
    teaser.hidden = true;
    window.setTimeout(() => open("completed signup"), 120);
  } else if (preview) {
    buildTracks();
    resetReels();
  } else {
    setCopy("invite");
    showStage("reveal");
    if (revealButton) revealButton.disabled = true;
  }
  if (preview) {
    teaser.hidden = false;
    const manualPreview = new URLSearchParams(location.search).has("manual");
    if (!manualPreview) window.setTimeout(() => open("preview"), 1200);
  } else {
    installProductionTriggers();
  }
})();

